import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/sendManualForSingleWorkOrder`;

export const ROUTE: RouteDefinition = `${baseRoute}/sendManualForSingleWorkOrder`;

export const URL = (): RouteDefinition => `${baseRoute}/sendManualForSingleWorkOrder`;
